import { render, staticRenderFns } from "./6-door.vue?vue&type=template&id=5c7f53e1&scoped=true&"
import script from "./6-door.vue?vue&type=script&lang=js&"
export * from "./6-door.vue?vue&type=script&lang=js&"
import style0 from "./6-door.vue?vue&type=style&index=0&id=5c7f53e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f53e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7f53e1')) {
      api.createRecord('5c7f53e1', component.options)
    } else {
      api.reload('5c7f53e1', component.options)
    }
    module.hot.accept("./6-door.vue?vue&type=template&id=5c7f53e1&scoped=true&", function () {
      api.rerender('5c7f53e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-door.vue"
export default component.exports